<template id="regForm">
<section class="registrationColumnLogin">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-sm-10 col-md-offset-3 col-sm-offset-1 col-xs-12">
        <div class="col-md-12 col-sm-12" id="a_email">
          <div class="inputBlock">
            <label for="">{{res.email}}</label>
            <div v-if="error.email" v-on:click="removeErr($event,'email')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.email}}</p>
            </div>
            <div class="inputOuter">
              <input :readonly="isValidToken" type="email" v-on:focus="removeErr($event,'email')" :class="error.email?'form-control errorMessage inputText':'form-control inputText'" placeholder="" v-model="reseller.email">
              <span><img src="images/mailicon.png" alt=""></span></div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" id="a_password" v-if="isValidToken">
          <div class="inputBlock">
            <label for="">{{res.password}}</label>
            <div v-if="error.password" v-on:click="removeErr($event,'password')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.password}}</p>
            </div>
            <div class="inputOuter lock">
              <input type="password" v-on:focus="removeErr($event,'password')" :class="error.password?'form-control errorMessage inputText':'form-control inputText'" placeholder="" v-model="reseller.password">
              <span><img src="images/lockicon.png" alt=""></span></div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" id="a_cpassword" v-if="isValidToken">
          <div class="inputBlock">
            <label for="">{{res.cpassword}}</label>
            <div v-if="error.cpassword" v-on:click="removeErr($event,'cpassword')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.cpassword}}</p>
            </div>
            <div class="inputOuter lock">
              <input type="password" v-on:focus="removeErr($event,'cpassword')" :class="error.cpassword?'form-control errorMessage inputText':'form-control inputText'" placeholder="" v-model="reseller.cpassword">
              <span><img src="images/lockicon.png" alt=""></span></div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" id="a_custcode" v-if="!isValidToken">
          <div class="inputBlock">
            <label for="">{{res.custcode}}</label>
            <div v-if="error.custcode" v-on:click="removeErr($event,'custcode')" class="erorContent">
              <p><i class="fa fa-exclamation-circle"></i> {{error.custcode}}</p>
            </div>
            <div class="inputOuter lock">
              <input type="text" v-on:focus="removeErr($event,'custcode')" :class="error.custcode?'form-control errorMessage inputText':'form-control inputText'" placeholder="" v-model="reseller.custcode">
              <span><img src="images/lockicon.png" alt=""></span></div>
          </div>
        </div>
        
        <div class="col-md-12 col-sm-12">
          <div class="centerbutton">
            <div id="recaptcha" class="g-recaptcha"></div>
            <input v-on:click="doChk()" type="submit" :class="(submitted?'submitted ':'')+'form-control submitButton'" :value="res.continue" v-if="isValidToken">
            <input v-on:click="doChk()" type="submit" :class="(submitted?'submitted ':'')+'form-control submitButton'" :value="res.submit" v-else>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>

import utils from './Utils.vue'

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'resetPwd',
  props:['name', 'token', 'countries', 'common_res', 'res'],
  data () {
    return {
      reseller:{},
      submitted:false,
      error:{}
    }
  },
  computed: {
    isValidToken:function() {
      return this.token != null && this.token.email != '';
    }
  },
  components: {
  },
  created: function() {
    if (this.token != null && this.token.email != '') {
      this.reseller.email = this.token.email;
      this.reseller.token = this.token.token;
    }
  },
  methods: {
    initReCaptcha: function() {
      var self = this;
      setTimeout(function() {
          if(typeof grecaptcha === 'undefined') {
              self.initReCaptcha();
          }
          else {
              grecaptcha.render('recaptcha', {
                  sitekey: '6LfX_28UAAAAAKVy8qQjPz_yYFLwrOHeYdX_bwMk',
                  size: 'invisible',
                  //badge: 'inline',
                  callback: self.doAction
              });
          }
      }, 100);
    },
    validate: function() {
      if (this.submitted) return;
      grecaptcha.execute();
    },
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    doAction:function(response) {
      if (this.isValidToken) {
        this.doReset(response);
      } else {
        this.doReset(response);
      }
    },
    doChk:function() {
      var self = this;
      var isok = true;
      var goto = null;
      if (!this.chk('email', /^.{1,}$/, this.res.email_err)) {
        isok = false;
        if (!goto) goto = 'email';
      } else if (!this.chk('email', /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i, this.res.email_invalid)) {
        isok = false;
        if (!goto) goto = 'email';
      }
      if (this.isValidToken) {
        if (!this.chk('password', /^.{1,}$/, this.res.password_err)) {
          if (!goto) goto = 'password';
          isok = false;
        }
        if (!this.chk('cpassword', /^.{1,}$/, this.res.cpassword_err)) {
          if (!goto) goto = 'cpassword';
          isok = false;
        } else if (this.reseller.password != this.reseller.cpassword) {
          this.error['cpassword'] = this.res.cpassword_wrong;
          if (!goto) goto = 'cpassword';
          isok = false;
        }
      } else {
        if (!this.chk('custcode', /^.{1,}$/, this.res.custcode_err)) {
          if (!goto) goto = 'custcode';
          isok = false;
        }
      }
      if (isok) {
        this.validate();
      } else {
        if (goto) {
          $("#a_"+goto)[0].scrollIntoView();
          goto = null;
        }
        var fd = utils.saveJSONToForm(this.reseller);
      }
      this.$forceUpdate();
    },
    doReset:function(response) {
      var self = this;
      if (this.submitted) return;
      this.submitted = true;
      if (response != null) {
        this.reseller['g-recaptcha-response'] = response;
      }
      var target = 'resetpwd.is';
      if (this.isValidToken) {
        target = 'changePwd.is';
      }
      if (1==1) {
console.log(this.reseller, target);
        self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
        utils.saveData({
            url: utils.getServerPath()+'/reseller/'+target,
            mode: 'insert',
            repos: 'db',
            value: utils.saveJSONToForm(this.reseller),
            name: 'reg.reseller'
          }, function(success, data) {
            self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
            if (success) {
              if (data.success != 1) {
                Object.keys(data.form).forEach(function(key) {
                  if (data.form[key] != 0) {
                    self.error[key] = " Invalid value";
                    $("#a_"+key)[0].scrollIntoView();
                  }
                });
                if (data.success == -2) {
                  $("#a_email")[0].scrollIntoView();
                  self.error['email'] = self.res.wrong_info;
                } else if (data.success == -3) {
                  $("#a_email")[0].scrollIntoView();
                  self.error['email'] = self.res.wrong_info;
                }
                self.$forceUpdate();
              } else {
                if (self.isValidToken) {
                  self.$emit('iposevent', 'dochange', self.reseller);
                } else {
                  self.$emit('iposevent', 'doreset', self.reseller);
                }
                return;
              }
            }
            self.submitted = false;
            grecaptcha.reset();
        });
      } else {
      }
      self.$forceUpdate();
    },
    removeErr: function(evt, name) {
      console.log(name);
      delete this.error[name];
      this.$forceUpdate();
    }
  },
  mounted: function() {
    this.initReCaptcha();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResetPwd.vue